import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { ChevronRight } from 'react-bootstrap-icons';
import CustomContext from '../../custom-context';
import { BOOKING_FORM_ANALYTICS_PROPS } from '../components/BookingForm/bookingFormAnalytics';

export default function ButtonComponent(props) {
	const {
		analyticsTrackTitle,
		analyticsTitle,
		windowLocationHref,
		buttonName,
		iconVisible,
		buttonShape,
	} = props;
	const { setOpen } = useContext(CustomContext);

	const buttonClass =
		buttonShape === 'rectangle' ? 'btn-rectangle' : 'btn-round';

	if (
		buttonName === 'Enquire Now' ||
		buttonName === 'Book here' ||
		buttonName === 'Book Now' ||
		buttonName === 'Enquire'
	) {
		return (
			<Button
				className={buttonClass}
				onClick={() => {
					setOpen(true);
					window.analytics.track('Enquire Now Button Clicked', {
						title: 'Booking Form',
						action: 'Clicked',
						location: window.location.href,
						...BOOKING_FORM_ANALYTICS_PROPS,
					});
				}}
				variant='danger'
				size='lg'
			>
				{props.buttonName ? props.buttonName : 'Enquire Now'}
			</Button>
		);
	} else {
		return (
			<Button
				className={buttonClass}
				onClick={() =>
					window.analytics.track(analyticsTrackTitle, {
						title: analyticsTitle,
						action: 'Clicked',
						location: windowLocationHref,
					})
				}
			>
				{buttonName !== null ? buttonName : ''}{' '}
				{iconVisible ? <ChevronRight className='btn-icon' size={18} /> : ''}
			</Button>
		);
	}
}
